import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const NOTIFICATIONS_LIST = "notifications_list";
export const ADMIN_NOTIFICATIONS_LIST = "admin_notifications_list";
export const BROKERS_SIMPLE_LIST = "brokers_simple_list";
export const CREATE_NOTIFICATION = "create_notification";
export const UPDATE_NOTIFICATION = "update_notification";
export const DELETE_NOTIFICATION = "delete_notification";
export const GET_NOTIFICATION_DETAILS = "get_notification_details";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const CLEAR_NOTIFICATION_ERRORS = "clearNotificationErrors";

// mutation types
export const SET_NOTIFICATION_ERROR = "setNotificationError";
export const REMOVE_NOTIFICATION_ERRORS = "removeNotificationErrors";

const state = {
    errors: null
};


const actions = {
    [NOTIFICATIONS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simple("api/notifications")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_NOTIFICATION_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [ADMIN_NOTIFICATIONS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/adminnotifications?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_NOTIFICATION_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [BROKERS_SIMPLE_LIST](context) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simple("api/brokerssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_NOTIFICATION_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [CREATE_NOTIFICATION](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createnotification", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_NOTIFICATION_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [UPDATE_NOTIFICATION](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatenotification", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_NOTIFICATION_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [DELETE_NOTIFICATION](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletenotification", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_NOTIFICATION_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [GET_NOTIFICATION_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getnotificationdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_NOTIFICATION_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [CLEAR_NOTIFICATIONS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/clearnotifications", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_NOTIFICATION_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_NOTIFICATION_ERROR, response.errors);
                });
        });
    },
    [CLEAR_NOTIFICATION_ERRORS](context) {
        context.commit(REMOVE_NOTIFICATION_ERRORS);
    },
};

const mutations = {
    [SET_NOTIFICATION_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_NOTIFICATION_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
